import React from 'react';
import PropTypes from 'prop-types';
import AutocompleteFlyout from './autocomplete-flyout';
import dealsService from '../../services/deals-service';

const getDisplayText = result => `${result.code} - ${result.description}`;

const renderListItem = result => (
  <div>{`${result.code} - ${result.description}`}</div>
);

function ClientCodeAutocomplete({
  onChange,
  errorMessage,
  placeholder,
  initSearchTerm,
  onBlur,
}) {
  return (
    <div className="client-code-autocomplete">
      <AutocompleteFlyout
        initSearchTerm={initSearchTerm}
        fetchRequest={({ search }) => dealsService.getClientAccountCodes(search ? { search, page_size: 10 } : { page_size: 10 })}
        requestParams={{}}
        onChange={onChange}
        placeholder={placeholder}
        renderListItem={renderListItem}
        findSelectedResultAttribute={getDisplayText}
        errorMessage={errorMessage}
        clickReturnsAll
        minSearchLength={1}
        onBlur={onBlur}
        openUp
      />
    </div>
  );
}

ClientCodeAutocomplete.propTypes = {
  onChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  initSearchTerm: PropTypes.string,
  onBlur: PropTypes.func,
};

ClientCodeAutocomplete.defaultProps = {
  errorMessage: '',
  placeholder: 'Type to search client codes',
  initSearchTerm: '',
  onBlur: () => {},
};

export default ClientCodeAutocomplete;
